import { getTenantName } from '~/api/utils';

function setTenantObj(tenantName: any, tenantObj: any) {
  const { $axios, $api, $store } = useNuxtApp();
  $api.tenant = tenantObj;
  $store.commit('setTenant', tenantName);
  useTenant().value = tenantObj;
  useTenantName().value = tenantName;
  $axios.defaults.headers.common['x-tenant-id'] = tenantName;
}

export default defineNuxtPlugin(async () => {
  const { $config, ssrContext, $store } = useNuxtApp();

  let tenantsList: any;

  const onCreatedtenantGuard = () => {
    const tenantState = useTenant();
    let req;
    if (import.meta.server) {
      tenantsList = $config.application.tenants;
      req = ssrContext?.event?.node?.req;
      if (req && req.headers && req.headers['x-tenant-id']) {
        setTenantObj(
          req.headers['x-tenant-id'],
          tenantsList[req.headers['x-tenant-id'] as string],
        );
        // $store.setTenant(req.headers['x-tenant-id']);
        return;
      }
      if ($store.state.tenant) {
        setTenantObj($store.state.tenant, tenantsList[$store.state.tenant]);
        return;
      }
    }

    if (tenantState.value) {
      setTenantObj(useTenantName().value, tenantState.value);
      return;
    }

    const tenantNameFromRequest = getTenantName(req);
    if (tenantNameFromRequest) {
      setTenantObj(tenantNameFromRequest, tenantsList[tenantNameFromRequest]);
    }
  };

  onCreatedtenantGuard();
});
